import axios from 'axios'
import { ApiConfig } from '../../../../config/api'

export const getLpnUser = (
  asnId: number,
  page = 0,
  pageSize = 5,
  orderBy?: { field: string; direction: string }
) => {
  const url = new URL(`${ApiConfig.AsnDetailApi}/GetAsnDetailLpn`)

  url.searchParams.set('pageIndex', page.toString())

  url.searchParams.set('pageSize', pageSize.toString())

  url.searchParams.set('asnId', asnId.toString())

  if (orderBy) {
    url.searchParams.set(
      'sorters',
      JSON.stringify({ datafield: orderBy.field, sortOrder: orderBy.direction })
    )
  }

  return axios.get(url.toString())
}
